import axios from 'axios';
import { getUserToken } from '../../utils/localStoarege';
import { localToken, newClinicHudDoseApiCRUDUrl, newHudPackageApiCRUDUrl } from '../../constants/apis/new_hud_apis';


export const getNewHudPatientDoses = async (packageId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(newHudPackageApiCRUDUrl + packageId + "/doses/", config);
    return response;
};

export const newAddHudPatientDoses = async (packageId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(newHudPackageApiCRUDUrl + packageId + "/add-dose/", data, config);
    return response;
};

export const newUpdateHudPatientDoses = async (packageId, doseId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newHudPackageApiCRUDUrl + packageId + "/dose/" + doseId + "/", data, config);
    return response;
};

export const newPatientPackageDoseComment = async (doseId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newClinicHudDoseApiCRUDUrl + doseId + "/", data, config);
    return response;
};

export const deleteHudPatientPackageDose = async (packageId, doseId) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.delete(newHudPackageApiCRUDUrl + packageId + "/dose/" + doseId + "/", config);
    return response;
};

export const patchHudPatientPackageDose = async (packageId, doseId, data) => {
    const token = localToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(newHudPackageApiCRUDUrl + packageId + "/dose/" + doseId + "/", data, config);
    return response;
};